import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useCartBasicInfo } from "../../hooks/useCart";
import Cart from "../Cart";
import { icCart } from "../image/image-src";
import Icon from "../image/Icon";
import { useCartBtn } from "../../hooks/useCartBtn";

export const CartBtn: FC = () => {
  const location = useLocation();
  const activePath = (location.pathname ?? "").split("/")[1];
  const { data: cartBasicInfo } = useCartBasicInfo();
  const { isCartOpen, setIsCartOpen, cartRef } = useCartBtn();

  return (
    <div className="relative">
      <button
        className={`header-icon ${activePath === "shopping-cart" ? "active-header" : ""}`}
        onClick={() => setIsCartOpen(!isCartOpen)}
      >
        <Icon className="mx-auto size-5" src={icCart} alt="Shopping Cart" />
      </button>
      {!!cartBasicInfo?.total && (
        <div className="absolute -right-[0.1875rem] -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-[#DA3838] text-xs font-semibold text-white">
          {cartBasicInfo.total}
        </div>
      )}
      {isCartOpen && (
        <div ref={cartRef} className="absolute right-0">
          <Cart onGoToCart={() => setIsCartOpen(false)} />
        </div>
      )}
    </div>
  );
};
